import { apiErrorMessage } from './error_utils';
import { t } from '../i18n';

// A warning or an error is a sentence the player has to read and act on, where
// the plain success line is one they can ignore.
const SHORT_DISMISS_MS = 3000;
const LONG_DISMISS_MS = 8000;

// The API answers 200 with a `warning` when it started the catch-up for one
// platform and cannot for the other, so "retrieving matches" alone would hide
// the half that is never coming. Matches are on their way either way, which is
// why this is not an error.
const retrievalStartedMessage = (response) => {
  const warning = response?.data?.warning;

  if (typeof warning === 'string' && warning.trim()) {
    return { messageType: 'warning', messageText: warning };
  }

  return { messageType: 'success', messageText: t('shared.match_retrieval.started') };
};

const retrievalFailedMessage = (error) => ({
  messageType: 'error',
  messageText: apiErrorMessage(error, t('shared.match_retrieval.failed')),
});

const messageDismissDelay = ({ messageType }) => (
  messageType === 'success' ? SHORT_DISMISS_MS : LONG_DISMISS_MS
);

export {
  retrievalStartedMessage,
  retrievalFailedMessage,
  messageDismissDelay,
  SHORT_DISMISS_MS,
  LONG_DISMISS_MS,
};
